/* eslint-disable */
<template>

  <div>
    <vx-card class="mb-4">
      <div  style="overflow-x: auto ">
        <div class="md-stepper-horizontal" >
          <div class="md-step" :ref="'step-'+step.active+'-'+step.completed"
              v-bind:class="[{ active: step.active , done: step.completed }]"
              v-for="(step, index) in steps" :key="index">
            <div class="md-step-circle"><span>{{ index + 1 }}</span></div>
            <div class="md-step-title">{{ step.title }}</div>
            <div class="md-step-optional">{{ step.userEmail }}</div>
            <div class="md-step-bar-left"></div>
            <div class="md-step-bar-right"></div>
          </div>
        </div>
      </div>
    </vx-card>

    <vs-row class="mb-2">
      <vs-col>
        <h2>{{ title }}</h2>
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col>
        <div>
          <span v-if="propose.lastSla && propose.lastSla.userAssigned && !isCurrentUserAssigned()">Em análise por: {{ propose.lastSla.userAssigned.name }} {{ propose.lastSla.userAssigned.lastName}}</span>
          <span v-if="propose.lastSla && propose.lastSla.userAssigned && !isCurrentUserAssigned() && propose.assignable">
            <vs-button size="small" class="bg-warning-gradient ml-2" style="cursor: pointer" @click="assignUser()"><span class="font-semibold">Alterar</span></vs-button>
        </span>
          <vs-button class="bg-success-gradient ml-2"
                     v-if="propose.lastSla && !propose.lastSla.userAssigned && propose.status !== 'DONE' && propose.assignable"
                     @click="assignUser()">Assinar</vs-button>

          <vs-button class="bg-primary ml-2" @click="back">Voltar</vs-button>
        </div>
      </vs-col>
    </vs-row>

    <proposta-analysis
      class="mt-3"
      v-if="propose.lastSla.view === 'ANALYSIS'"
      :proposeDb="proposeDb"
      :balancesDb="balances"
      ref="propostaAnalysis"/>

    <proposta-create
      class="mt-3"
      v-if="propose.lastSla.view === 'CREATE'"
      :proposeDb="proposeDb"
      ref="propostaCreate"/>

    <proposta-report
      class="mt-3"
      v-if="propose.lastSla.view === 'REPORT'"
      :proposeDb="proposeDb"
      ref="porpostaReport"
    />

  </div>

</template>

<script>
import axios from 'axios'
import PropostaAnalysis from '../../components/propose/PropostaAnalysis'
import PropostaCreate from '../../components/propose/PropostaCreate'
import PropostaReport from '../../components/propose/PropostaReport'

export default {
  name: 'Proposta',
  props:{
    guid: String
  },
  components:{
    PropostaAnalysis,
    PropostaCreate,
    PropostaReport
  },
  data () {
    return {
      title: null,
      propose: {
        codigo: null,
        proposeType: null,
        createdAt: null,
        operationType: null,
        guid: null,
        config: {
          approved: null,
          client: { guid: null },
          guarantor: { guid: null },
          balanceDtoTable: null,
          balances: null,
          guaranteeType: null,
          guaranteePeriod: null,
          values: [],
          serasa: null,
          compliance: null,
          balance: null,
        },
        groupedValues: null,
        approved: null,
        assignable: null,
        approvedDescription: null,
        proposeSla: [],
        createdBy: null,
        status: null,
        lastSla: {},
        slaMessage: {},
        action: null,
        files: [],
        balances: [],
      },
      proposeDb: {
        codigo: null,
        proposeType: null,
        createdAt: null,
        operationType: null,
        guid: null,
        config: {
          approved: null,
          client: { guid: null },
          guarantor: { guid: null },
          balanceDtoTable: null,
          balances: null,
          guaranteeType: null,
          guaranteePeriod: null,
          values: [],
          serasa: null,
          compliance: null,
          balance: null,
        },
        groupedValues: null,
        approved: null,
        assignable: null,
        approvedDescription: null,
        proposeSla: [],
        createdBy: null,
        status: null,
        lastSla: {},
        slaMessage: {},
        action: null,
        files: [],
        balances: [],
      },
      balances: []
    }
  },
  computed: {
    steps: function() {
      const proposeSla = [];
      if (!this.propose.proposeSla) {
        return proposeSla
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties

      this.propose.proposeSla.forEach(function(item) {
        let sla = {}
        sla = {
            icon: 'assignment',
            name: item.id,
            title: item.statusDescription,
            completed: !!item.end,
            active: !!item.start,
            userEmail: item.userEmail
          }
          proposeSla.push(sla)
        } )
      this.scrollToActive(proposeSla)
      return proposeSla
    }
  },
  beforeMount () {
    this.loadPropose()
  },
  methods: {

    scrollToActive(steps) {
      this.$nextTick(() => {
        var activeStep = steps.find(el => el.active && !el.completed)
        if (activeStep) {
          const el = this.$refs['step-true-false'];
          if (el) {
            // Use el.scrollIntoView() to instantly scroll to the element
            el[0].scrollIntoView({block: "end", inline: "start"});
          }
        }
      })
    },

    loadPropose () {
      axios.get(`${process.env.VUE_APP_API  }/api/v1/propose/${this.guid}`)
        .then((response) => {
          this.propose = response.data
          this.checkPerfilUser(this.propose)
        })
        .finally(() => {
          this.loadBalances()
          this.title = this.propose.codigo + ' - ' + this.propose.config.guarantor.name
        })
    },

    loadBalances () {
      this.balances = this.propose.balances
      this.proposeDb = this.propose
    },

    statusSla(currentProposeSla) {
      if (currentProposeSla && currentProposeSla.statusSla){
        return currentProposeSla.statusSla
      }
    },

    checkPerfilUser(propose) {
      if (propose && propose.guid){
        axios.get(`${process.env.VUE_APP_API  }/api/v1/propose/${propose.guid}/check-perfil`)
        .then((response) => {
          propose.assignable = response.data
        }).catch(ex => {
          this.$vs.notify({
            color:'danger',
            text:ex.response ? ex.response.data : ex.message
          })
          propose.assignable = false
        })
      }
    },

    assignUser() {
      if (localStorage.currentUser) {
        var currentUser = JSON.parse(localStorage.currentUser)
        if (!this.isCurrentUserAssigned() && this.propose.lastSla && this.propose.lastSla.userAssigned) {
          this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: 'Alterar usuário',
            text: 'A proposta está em análise por outro usuário. Deseja mesmo alterar?',
            accept: this.promptChangeAssignedUser,
            parameters: [this.propose, currentUser],
            acceptText: 'Ok'
          })
        } else if (!this.propose.lastSla.userAssigned || this.propose.lastSla.userAssigned.email == null) {
          this.changeAssignedUser(this.propose, currentUser)
        }
      }
    },

    isCurrentUserAssigned() {
      if (localStorage.currentUser && this.propose.lastSla && this.propose.lastSla.userAssigned) {
        var currentUser = JSON.parse(localStorage.currentUser)
        if (currentUser.email === this.propose.lastSla.userAssigned.email) {
          return true
        }
      }
      return false
    },

    promptChangeAssignedUser(parameters) {
      this.changeAssignedUser(parameters[0], parameters[1])
    },

    changeAssignedUser(propose, currentUser) {
      axios.post(`${process.env.VUE_APP_API  }/api/v1/propose-sla-assign`,
        {
          proposeId: propose.guid,
          userEmail: currentUser.email
        })
        .then(() => {
          this.$vs.notify({
            color:'success',
            text:'Usuário da proposta alterado'
          })
          this.loadPropose()
        })
        .catch(ex => {
          this.$vs.notify({
            color:'danger',
            text:ex.response ? ex.response.data : ex.message
          })
          this.loadPropose()
        })
    },

    back() {
      this.$router.push({path: '/propose'})
    },

  }
}
</script>

<style scoped>
html {
	-webkit-font-smoothing: antialiased!important;
	-moz-osx-font-smoothing: grayscale!important;
	-ms-font-smoothing: antialiased!important;
}
body {
  font-family: 'Open Sans', sans-serif;
  font-size:16px;
  color:#555555;
}
.md-stepper-horizontal {
	display:table;
	width:100%;
	margin:0 auto;
	background-color:#FFFFFF;
}
.md-stepper-horizontal .md-step {
	display:table-cell;
	position:relative;
	padding:20px;
}
.md-stepper-horizontal .md-step:hover,
.md-stepper-horizontal .md-step:active {
	background-color:rgba(0,0,0,0.04);
}
.md-stepper-horizontal .md-step:active {
	border-radius: 15% / 75%;
}
.md-stepper-horizontal .md-step:first-child:active {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}
.md-stepper-horizontal .md-step:last-child:active {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}
.md-stepper-horizontal .md-step:hover .md-step-circle {
	background-color: #4e5e80;
}
.md-stepper-horizontal .md-step:first-child .md-step-bar-left,
.md-stepper-horizontal .md-step:last-child .md-step-bar-right {
	display:none;
}
.md-stepper-horizontal .md-step .md-step-circle {
	width:30px;
	height:30px;
	margin:0 auto;
	background-color:#999999;
	border-radius: 50%;
	text-align: center;
	line-height:30px;
	font-size: 16px;
	font-weight: 600;
	color:#FFFFFF;
}
.md-stepper-horizontal.green .md-step.active .md-step-circle {
	background-color:#00AE4D;
}
.md-stepper-horizontal.orange .md-step.active .md-step-circle {
	background-color:#F96302;
}
.md-stepper-horizontal .md-step.active .md-step-circle {
	background-color:#4e5e80;
}
.md-stepper-horizontal .md-step.done .md-step-circle:before {
	font-family:'feather';
	font-weight:100;
	content: "\e83f";
}
.md-stepper-horizontal .md-step.done .md-step-circle *,
.md-stepper-horizontal .md-step.editable .md-step-circle * {
	display:none;
}
.md-stepper-horizontal .md-step.editable .md-step-circle {
	-moz-transform: scaleX(-1);
	-o-transform: scaleX(-1);
	-webkit-transform: scaleX(-1);
	transform: scaleX(-1);
}
.md-stepper-horizontal .md-step.editable .md-step-circle:before {
	font-family:'feather';
	font-weight:100;
	content: "\e867";
}
.md-stepper-horizontal .md-step .md-step-title {
	margin-top:16px;
	font-size:16px;
	font-weight:600;
}
.md-stepper-horizontal .md-step .md-step-title,
.md-stepper-horizontal .md-step .md-step-optional {
	text-align: center;
	color:rgba(0,0,0,.26);
}
.md-stepper-horizontal .md-step.active .md-step-title {
	font-weight: 600;
	color:rgba(0,0,0,.87);
}
.md-stepper-horizontal .md-step.active.done .md-step-title,
.md-stepper-horizontal .md-step.active.editable .md-step-title {
	font-weight:600;
}
.md-stepper-horizontal .md-step .md-step-optional {
	font-size:12px;
}
.md-stepper-horizontal .md-step.active .md-step-optional {
	color:rgba(0,0,0,.54);
}
.md-stepper-horizontal .md-step .md-step-bar-left,
.md-stepper-horizontal .md-step .md-step-bar-right {
	position:absolute;
	top:33px;
	height:1px;
	border-top:1px solid #DDDDDD;
}
.md-stepper-horizontal .md-step .md-step-bar-right {
	right:0;
	left:50%;
	margin-left:20px;
}
.md-stepper-horizontal .md-step .md-step-bar-left {
	left:0;
	right:50%;
	margin-right:20px;
}
</style>
